import React, { useState, useEffect } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { useTranslation } from "react-i18next";
import { ShieldCheck, X } from "lucide-react";

// Modal de vérification KYC
export const KYCVerificationModal = ({ isOpen, onClose, verificationUrl, onComplete }) => {
    const { t } = useTranslation(['settings', 'common']);
    const [isLoading, setIsLoading] = useState(true);

    useEffect(() => {
        if (isOpen && verificationUrl) {
            setIsLoading(true);
        }
    }, [isOpen, verificationUrl]);

    const handleIframeLoad = () => {
        setIsLoading(false);
    };

    return (
        <AnimatePresence>
            {isOpen && (
                <div className="fixed inset-0 z-50 flex items-center justify-center">
                    <motion.div
                        initial={{ opacity: 0 }}
                        animate={{ opacity: 1 }}
                        exit={{ opacity: 0 }}
                        className="absolute inset-0 bg-black/60 backdrop-blur-sm"
                    />
                    <motion.div
                        initial={{ scale: 0.95, opacity: 0 }}
                        animate={{ scale: 1, opacity: 1 }}
                        exit={{ scale: 0.95, opacity: 0 }}
                        transition={{ type: "spring", damping: 25, stiffness: 300 }}
                        className="relative bg-white rounded-2xl w-full max-w-2xl h-[85vh] md:h-[80vh] mx-4 shadow-2xl overflow-hidden z-10 flex flex-col"
                    >
                        {/* Header */}
                        <div className="flex justify-between items-center px-5 py-4 border-b border-gray-100 bg-gray-50">
                            <div className="flex items-center gap-3">
                                <ShieldCheck className="text-blue-600" size={22} />
                                <h3 className="text-lg font-bold text-gray-800">
                                    {t('settings:kyc.verificationTitle')}
                                </h3>
                            </div>
                            <button
                                onClick={onClose}
                                className="text-gray-400 hover:text-gray-600 p-1 rounded-full hover:bg-gray-100 transition-colors"
                            >
                                <X size={22} />
                            </button>
                        </div>

                        {/* Content */}
                        <div className="flex-1 relative">
                            {isLoading && (
                                <div className="absolute inset-0 flex items-center justify-center bg-white z-10">
                                    <div className="flex flex-col items-center gap-3">
                                        <div className="animate-spin rounded-full h-10 w-10 border-4 border-blue-600 border-t-transparent" />
                                        <p className="text-sm text-gray-600">{t('settings:kyc.loading')}</p>
                                    </div>
                                </div>
                            )}
                            {verificationUrl && (
                                <iframe
                                    src={verificationUrl}
                                    className="w-full h-full border-0"
                                    onLoad={handleIframeLoad}
                                    title="Vérification KYC"
                                    allow="camera; microphone"
                                />
                            )}
                        </div>

                        {/* Footer */}
                        <div className="px-5 py-3 border-t border-gray-100 bg-gray-50 flex items-center justify-between">
                            <p className="text-xs text-gray-500">
                                {t('settings:kyc.secureByDidit')}
                            </p>
                            <button
                                onClick={onClose}
                                className="px-4 py-2 text-sm font-medium text-gray-600 hover:text-gray-800 hover:bg-gray-100 rounded-lg transition-colors"
                            >
                                {t('common:close')}
                            </button>
                        </div>
                    </motion.div>
                </div>
            )}
        </AnimatePresence>
    );
};
